/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setupprofileplacedescription3Inputs */

const en_setupprofileplacedescription3 = /** @type {(inputs: Setupprofileplacedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A café, a bar, a club – a place people go to.`)
};

const de_setupprofileplacedescription3 = /** @type {(inputs: Setupprofileplacedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Lokal, eine Bar, ein Club – ein Ort, an den Leute kommen.`)
};

/**
* | output |
* | --- |
* | "A café, a bar, a club – a place people go to." |
*
* @param {Setupprofileplacedescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setupprofileplacedescription3 = /** @type {((inputs?: Setupprofileplacedescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setupprofileplacedescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setupprofileplacedescription3(inputs)
	return de_setupprofileplacedescription3(inputs)
});
export { setupprofileplacedescription3 as "setupProfilePlaceDescription" }